<template>
  <div>
    <div class="card">
      <h2>Admin — Branch Overview</h2>
      <div class="row" style="margin-top:10px;">
        <div class="col">
          <label>Branch</label>
          <select v-model="branchId" class="input">
            <option v-for="b in branches" :key="b" :value="b">{{ b }}</option>
          </select>
        </div>
        <div class="col">
          <label>Month</label>
          <input type="month" v-model="monthKey" class="input" />
        </div>
      </div>
    </div>

    <div class="row" style="margin-top:14px;">
      <div class="col">
        <div class="card">
          <h3>Branch Summary ({{ branchId }})</h3>
          <div class="row" style="margin-top:12px;">
            <div class="col"><div class="kpi">₹{{ (summary.totalSales||0).toLocaleString('en-IN') }}</div><div class="helper">Monthly Sales</div></div>
            <div class="col"><div class="kpi">{{ summary.achPct.toFixed(1) }}%</div><div class="helper">Achievement vs 60L</div></div>
            <div class="col"><div class="kpi">{{ (summary.monthRate*100).toFixed(2) }}%</div><div class="helper">Monthly Rate</div></div>
            <div class="col"><div class="kpi">₹{{ (summary.grandTotal||0).toLocaleString('en-IN') }}</div><div class="helper">Total Incentives</div></div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="margin-top:14px;">
      <div class="col">
        <div class="card">
          <h3>Sales — {{ monthKey }}</h3>
          <sales-table
            :rows="rows"
            :editable="true"
            @edit="goEdit"
            @delete="onDelete"
          />
        </div>
      </div>
    </div>

    <!-- Admin — quick enrolment -->
    <div class="card" style="margin-top:14px;">
    <h3>User Enrolment</h3>
    <div class="row" style="margin-top:10px;">
        <div class="col"><input class="input" v-model="nu.id" placeholder="ID (e.g., E-SIR-1003)"></div>
        <div class="col"><input class="input" v-model="nu.name" placeholder="Name"></div>
        <div class="col">
        <select class="input" v-model="nu.role">
            <option value="employee">employee</option>
            <option value="manager">manager</option>
        </select>
        </div>
        <div class="col"><input class="input" v-model="nu.branchId" placeholder="Branch (e.g., SIR)"></div>
        <div class="col"><input class="input" v-model="nu.password" placeholder="Temp password"></div>
    </div>
    <div style="margin-top:10px;">
        <button class="btn" @click="createUser">Create User</button>
    </div>

    <table class="table" style="margin-top:12px;">
        <thead><tr><th>ID</th><th>Name</th><th>Role</th><th>Branch</th><th>Status</th><th>Action</th></tr></thead>
        <tbody>
        <tr v-for="u in allUsers" :key="u.id">
            <td>{{ u.id }}</td>
            <td>{{ u.name }}</td>
            <td>{{ u.role }}</td>
            <td>{{ u.branchId }}</td>
            <td><span :class="u.active ? 'badge' : 'error'">{{ u.active ? 'active' : 'inactive' }}</span></td>
            <td><button class="btn secondary" @click="toggle(u.id)">Toggle</button></td>
        </tr>
        </tbody>
    </table>
    </div>

  </div>
</template>

<script>
import dayjs from 'dayjs'
import SalesTable from '../components/SalesTable.vue'
import { computeManagerMonthSummary } from '../utils/incentives'

export default {
  components: { SalesTable },
  data(){
    return {
      branchId: '',
      monthKey: dayjs().format('YYYY-MM'),
      nu: { id:'', name:'', role:'employee', branchId:'', password:'' }
    }
  },
  computed:{
    branches(){ return this.$store.getters['auth/branches'] },
    rows(){
      if (!this.branchId) return []
      return this.$store.getters['sales/byBranchMonth']({ branchId: this.branchId, monthKey: this.monthKey })
    },
    summary(){
      const exp = this.$store.getters['expenses/get'](this.branchId, this.monthKey)
      return computeManagerMonthSummary(this.rows, exp)
    },
    allUsers(){ return this.$store.getters['auth/users'] }
  },
  created(){
    const list = this.$store.getters['auth/branches']
    this.branchId = list && list.length ? list[0] : ''
  },
  methods:{
    goEdit(r){ this.$router.push({ name: 'admin-sale-edit', params: { id: r.id } }) },
    onDelete(r){
      if (confirm('Delete this sale?')) {
        this.$store.dispatch('sales/adminRemoveSale', r.id)
      }
    },
    toggle(id){ this.$store.dispatch('auth/toggleActive', id) },
    createUser(){
        try{
        this.$store.dispatch('auth/addUser', { ...this.nu })
        this.nu = { id:'', name:'', role:'employee', branchId:'', password:'' }
        alert('User created')
        }catch(e){ alert(e.message) }
    }
  }
}
</script>
